export const nav = [
  {
    text: "home",
    path: "/",
  },
  {
    text: "about",
    path: "/about",
  },
  {
    text: "services",
    path: "/services",
  },
 
 
  {
    text: "contact",
    path: "/contact",
  },
]
export const featured = [
  {
    cover: "../images/hero/h1.png",
    name: "Civil Works",
    total: "Includes construction, maintenance, and improvement of infrastructure projects that are essential for the functioning of a society such as roads, bridges, dams, airports, railways, canals, pipelines, and buildings.",
  
   
  },
  {
    cover: "../images/hero/h2.png",
    name: "Restoration",
    total: "Includes the design, engineering, procurement, construction and other work with respect to the Restoration of Affected Property.",
  },
  {
    cover: "../images/hero/h3.png",
    name: "Structural Repair",
    total: "Includes the repairing of foundation, wall and roof support columns, roof joists and the roof deck of the Building.",
  },
  {
    cover: "../images/hero/h4.png",
    name: "Waterproofing",
    total: "Involves applying specialized materials or coatings to prevent water penetration and protect against water damage.",
  },
  {
    cover: "../images/hero/h6.png",
    name: "Plumbing",
    total: "Invloves installation, repair, and maintenance of plumbing systems to ensure proper functioning of water supply and wastewater management.",
  },
  {
    cover: "../images/hero/h7.png",
    name: "Fabrication",
    total: "Involves constructing products by combining typically standardised parts using one or more individual processes.",
  },
    
  {
    cover: "../images/hero/h8.png",
    name: "PCC & POP & RCC",
    total: "PCC  is used as a foundational layer in construction. POP is used for creating smooth surfaces on walls and ceilings. RCC is a composite material combining concrete and steel reinforcement bars for added strength in construction projects.",
  },
  {
    cover: "../images/hero/h9.png",
    name: "Printing Works",
    total: "Involves covering the surfaces of wood, metal, masonry, plastered walls, slabs, etc. To protect the surfaces from atmospheric influences and to preserve them from decay, oxidation, and corrosion.",
  },
  {
    cover: "../images/hero/h10.png",
    name: "New Swimming Pool & Service",
    total: "Involves designing and building a new swimming pool involves creating a customized layout and structure that meets the specific requirements and preferences of the client." ,
  },
  
 
]
export const list = [
  {
    id: 1,
    cover: "../images/list/Restoration.jpg",
    name: "Restoration Works",
    
  },
  {
    id: 2,
    cover: "../images/list/Structural.jpg",
    name: "Structural Repairs",
    
  },
  {
    id: 3,
    cover: "../images/list/POP.jpg",
    name: "POP",
    
  },
  {
    id: 4,
    cover: "../images/list/Painting.jpg",
    name: "Painting Works",
    
  },
  {
    id: 5,
    cover: "../images/list/Electrical.jpg",
    name: "Electrical works in construction",
    
  },
  {
    id: 6,
    cover: "../images/list/Fabrication.jpg",
    name: "Fabrication",
    
  },
]



export const footer = [
 
  {
    title: "CONTACT US",
    text: [{ list: "Channabasayya G.K." }, { list: "Proprietor" }, { list: "9008659195" }, { list: "channu.kulkarni@gmail.com" }, { list: "#55, Oppo. Police Station" }, { list: "Kanakapura Main Road, Kaggalipura, Bangalore-560116" }],
  },
  
]
